import { EventEmitter } from '@angular/core';
var ModalComponent = (function () {
    function ModalComponent() {
        this.canIclose = true;
        this.large = false;
        this.ultralarge = false;
        this.dragable = true;
        this.resizable = true;
        this.modalHide = new EventEmitter();
    }
    ModalComponent.prototype.ngOnInit = function () {
        if (this.dragable == true) {
            $(".modal-header").on("mousedown", function (mousedownEvt) {
                var $draggable = $(this);
                var x = mousedownEvt.pageX - $draggable.offset().left, y = mousedownEvt.pageY - $draggable.offset().top;
                $("body").on("mousemove.draggable", function (mousemoveEvt) {
                    $draggable.closest(".modal-dialog").offset({
                        "left": mousemoveEvt.pageX - x,
                        "top": mousemoveEvt.pageY - y
                    });
                });
                $("body").one("mouseup", function () {
                    $("body").off("mousemove.draggable");
                });
                $draggable.closest(".modal").one("bs.modal.hide", function () {
                    $("body").off("mousemove.draggable");
                });
            });
            $(".modal-dialog").draggable();
        }
        if (this.resizable == true) {
            $(".modal-content").resizable({
                //alsoResize: ".modal-dialog",
                minHeight: 150,
                minWidth: 400
            });
            $('.modal').on('show.bs.modal', function () {
                $(this).find(".modal-body").css({
                    'max-height': '100%'
                });
            });
        }
    };
    return ModalComponent;
}());
export { ModalComponent };
